import { render, staticRenderFns } from "./Music.vue?vue&type=template&id=ab9f9638&scoped=true"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"
import style0 from "./Music.vue?vue&type=style&index=0&id=ab9f9638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9f9638",
  null
  
)

export default component.exports